import React from "react";
import "../Logistics.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiTruck,
} from "react-icons/fi";


const Logistics = () => {


    return (

        <>

            <Header />



            {/* =====================================================
                    HERO SECTION
            ===================================================== */}



            <section className="logistics-hero">


                <div className="logistics-overlay"></div>



                <div className="container">



                    <div className="logistics-hero-content">



                        <span className="logistics-tag">

                            Logistics Technology Solutions

                        </span>





                        <h1>


                            Transforming
                            <span> Logistics </span>
                            Through Smart Digital Innovation


                        </h1>





                        <p>

                            Kishancart Digital (OPC) Private Limited
                            empowers logistics companies, transportation
                            businesses, warehouses, and supply chain
                            organizations with innovative digital solutions.
                            We build smart logistics platforms that improve
                            fleet management, optimize delivery operations,
                            automate workflows, enhance visibility, and
                            enable data-driven decision making.

                        </p>





                        <div className="logistics-hero-btns">


                            {/* Future Buttons */}


                        </div>





                    </div>



                </div>



            </section>








            {/* =====================================================
                    BREADCRUMB
            ===================================================== */}



            <section className="logistics-breadcrumb">


                <div className="container">



                    <div className="breadcrumb">



                        <NavLink to="/">


                            <FiHome />


                            Home


                        </NavLink>





                        <FiChevronRight />





                        <span>

                            Solutions

                        </span>





                        <FiChevronRight />





                        <span className="active">


                            <FiTruck />


                            Logistics


                        </span>





                    </div>



                </div>



            </section>









            {/* =====================================================
                    LOGISTICS OVERVIEW
            ===================================================== */}



            <section className="logistics-overview">


                <div className="container">



                    <div className="overview-grid">





                        {/* LEFT CONTENT */}



                        <div className="overview-content">



                            <span className="section-tag">

                                Digital Logistics Solutions

                            </span>





                            <h2>


                                Smart Technology for
                                <span> Modern Logistics Operations</span>


                            </h2>






                            <p>


                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable logistics
                                technology solutions that help transportation
                                companies, logistics providers, and supply
                                chain businesses improve efficiency,
                                reduce operational costs, and manage
                                logistics operations effectively.


                            </p>







                            <p>


                                Our digital logistics platforms enable
                                fleet management, shipment tracking,
                                warehouse automation, route optimization,
                                inventory management, and real-time
                                analytics. We help businesses create
                                connected and efficient logistics
                                ecosystems through modern technologies.


                            </p>







                            <div className="overview-list">






                                <div className="overview-item">


                                    ✓ Fleet Management System


                                </div>





                                <div className="overview-item">


                                    ✓ Shipment Tracking Solutions


                                </div>





                                <div className="overview-item">


                                    ✓ Warehouse Management System


                                </div>





                                <div className="overview-item">


                                    ✓ Route Optimization


                                </div>





                                <div className="overview-item">


                                    ✓ Supply Chain Management


                                </div>





                                <div className="overview-item">


                                    ✓ Logistics Analytics Dashboard


                                </div>






                            </div>





                        </div>









                        {/* RIGHT CARDS */}



                        <div className="overview-cards">






                            <div className="overview-card">



                                <h3>


                                    Fleet Management


                                </h3>




                                <p>


                                    Monitor vehicles, drivers,
                                    fuel usage, maintenance schedules,
                                    and transportation operations
                                    through digital fleet solutions.


                                </p>




                            </div>








                            <div className="overview-card">



                                <h3>


                                    Shipment Tracking


                                </h3>




                                <p>


                                    Track shipments, deliveries,
                                    and logistics activities with
                                    real-time visibility and smart
                                    tracking technologies.


                                </p>




                            </div>








                            <div className="overview-card">



                                <h3>


                                    Warehouse Automation


                                </h3>




                                <p>


                                    Optimize warehouse operations,
                                    inventory movement, storage,
                                    and order processing through
                                    digital systems.


                                </p>




                            </div>








                            <div className="overview-card">



                                <h3>


                                    Logistics Analytics


                                </h3>




                                <p>


                                    Analyze transportation data,
                                    delivery performance, costs,
                                    and operational insights using
                                    real-time dashboards.


                                </p>




                            </div>







                        </div>






                    </div>





                </div>



            </section>






            {/*

                PART 2 STARTS HERE

                Logistics Challenges
                +
                Logistics Solutions


            */}

            {/* =====================================================
        LOGISTICS CHALLENGES
===================================================== */}


            <section className="logistics-challenges">


                <div className="container">


                    <div className="section-heading">


                        <span className="section-tag">

                            Industry Challenges

                        </span>




                        <h2>

                            Challenges in
                            <span> Modern Logistics Management</span>

                        </h2>




                        <p>

                            Logistics companies face challenges related to
                            transportation management, delivery efficiency,
                            shipment visibility, warehouse operations, and
                            supply chain coordination. Our digital logistics
                            solutions help businesses overcome these challenges
                            with advanced technology.

                        </p>



                    </div>








                    <div className="challenge-grid">






                        <div className="challenge-card">


                            <h3>

                                Fleet Management

                            </h3>


                            <p>

                                Managing multiple vehicles, drivers,
                                maintenance schedules, fuel costs, and
                                transportation operations efficiently.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Shipment Visibility

                            </h3>


                            <p>

                                Lack of real-time shipment tracking makes
                                it difficult to monitor deliveries and
                                provide accurate updates.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Route Optimization

                            </h3>


                            <p>

                                Optimize delivery routes, reduce travel
                                time, lower fuel consumption, and improve
                                transportation efficiency.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Warehouse Operations

                            </h3>


                            <p>

                                Improve warehouse management, inventory
                                movement, storage processes, and order
                                fulfillment operations.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Supply Chain Coordination

                            </h3>


                            <p>

                                Connect suppliers, warehouses, transporters,
                                and customers through integrated digital
                                supply chain solutions.

                            </p>


                        </div>








                        <div className="challenge-card">


                            <h3>

                                Data Management

                            </h3>


                            <p>

                                Collect and analyze logistics data to
                                improve forecasting, reporting, and
                                operational decision making.

                            </p>


                        </div>






                    </div>



                </div>



            </section>









            {/* =====================================================
        LOGISTICS SOLUTIONS
===================================================== */}



            <section className="logistics-solutions">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Our Logistics Solutions

                        </span>





                        <h2>

                            Comprehensive Digital Solutions for
                            <span> Logistics Industry</span>

                        </h2>





                        <p>

                            Kishancart Digital provides smart, scalable,
                            and technology-driven logistics solutions that
                            help transportation companies improve efficiency,
                            automate operations, and build connected supply
                            chain ecosystems.

                        </p>



                    </div>








                    <div className="solutions-grid">






                        <div className="solution-card">


                            <h3>

                                Fleet Management System

                            </h3>


                            <p>

                                Monitor vehicles, drivers, fuel usage,
                                maintenance schedules, and fleet performance
                                through centralized digital platforms.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Shipment Tracking Platform

                            </h3>


                            <p>

                                Provide real-time shipment tracking,
                                delivery updates, and complete logistics
                                visibility for businesses and customers.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Route Optimization Solutions

                            </h3>


                            <p>

                                Optimize transportation routes using
                                intelligent algorithms to reduce costs
                                and improve delivery efficiency.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Warehouse Management System

                            </h3>


                            <p>

                                Digitally manage inventory, warehouse
                                operations, storage, picking, and order
                                fulfillment processes.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Supply Chain Management

                            </h3>


                            <p>

                                Improve coordination between suppliers,
                                logistics partners, warehouses, and
                                customers through integrated platforms.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Delivery Management System

                            </h3>


                            <p>

                                Manage delivery scheduling, driver
                                assignments, customer notifications,
                                and delivery performance.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Logistics Mobile Application

                            </h3>


                            <p>

                                Provide mobile solutions for drivers,
                                customers, and logistics teams to access
                                services anytime.

                            </p>


                        </div>








                        <div className="solution-card">


                            <h3>

                                Logistics Analytics Dashboard

                            </h3>


                            <p>

                                Analyze transportation data, delivery
                                performance, operational costs, and
                                business insights through dashboards.

                            </p>


                        </div>







                    </div>



                </div>



            </section>

            {/* =====================================================
        LOGISTICS FEATURES
===================================================== */}


            <section className="logistics-features">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Key Features

                        </span>





                        <h2>

                            Powerful Features for
                            <span> Modern Logistics Platforms</span>

                        </h2>





                        <p>

                            Our logistics technology solutions include
                            advanced features that help businesses automate
                            transportation operations, improve visibility,
                            and manage supply chain activities efficiently.

                        </p>



                    </div>








                    <div className="features-grid">





                        <div className="feature-card">

                            <h3>

                                Fleet Tracking

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Driver Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Real-Time Shipment Tracking

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Route Optimization

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Delivery Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Warehouse Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Inventory Monitoring

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                GPS Integration

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Customer Notifications

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Logistics Reports

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Analytics Dashboard

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Secure Cloud Platform

                            </h3>

                        </div>





                    </div>



                </div>



            </section>









            {/* =====================================================
        BUSINESS BENEFITS
===================================================== */}



            <section className="logistics-benefits">


                <div className="container">





                    <div className="section-heading">


                        <span className="section-tag">

                            Business Benefits

                        </span>





                        <h2>

                            Why Logistics Companies Choose
                            <span> Kishancart Digital</span>

                        </h2>





                        <p>

                            Our digital logistics solutions help businesses
                            improve delivery performance, reduce operational
                            costs, increase visibility, and build efficient
                            supply chain operations.

                        </p>



                    </div>








                    <div className="benefits-grid">






                        <div className="benefit-card">


                            <h3>

                                Improved Delivery Efficiency

                            </h3>


                            <p>

                                Optimize transportation processes,
                                delivery routes, and logistics workflows
                                to improve overall efficiency.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Real-Time Visibility

                            </h3>


                            <p>

                                Track shipments, vehicles, and delivery
                                activities with complete operational
                                visibility.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Reduced Transportation Costs

                            </h3>


                            <p>

                                Minimize fuel expenses, delays, and
                                operational costs through intelligent
                                logistics management.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Better Customer Experience

                            </h3>


                            <p>

                                Provide accurate delivery updates,
                                faster services, and improved customer
                                communication.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Data-Driven Decisions

                            </h3>


                            <p>

                                Use logistics analytics, reports,
                                and real-time insights to make better
                                business decisions.

                            </p>


                        </div>








                        <div className="benefit-card">


                            <h3>

                                Scalable Logistics Platform

                            </h3>


                            <p>

                                Easily expand logistics operations
                                across multiple locations, fleets,
                                and business requirements.

                            </p>


                        </div>






                    </div>





                </div>



            </section>









            {/* =====================================================
        FOOTER
===================================================== */}


            <Footer />






            <Footer />



        </>


    );


};



export default Logistics;